<input
  class="form-control"
  type="date"
  [(ngModel)]="date"
  (change)="onChange($event)"
/>
